(function () {
  if (typeof theme === 'undefined') {
    return;
  }

  window.__bdlRecentlyViewed = true;

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function parseProduct(data) {
    if (!data) {
      return null;
    }

    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch (error) {
        return null;
      }
    }

    return data;
  }

  function readRecentMap() {
    if (theme.recentlyViewed && theme.recentlyViewed.recent && Object.keys(theme.recentlyViewed.recent).length) {
      return theme.recentlyViewed.recent;
    }

    try {
      var raw = window.localStorage.getItem('theme-recent');

      if (raw) {
        var parsed = JSON.parse(raw);

        if (theme.recentlyViewed) {
          theme.recentlyViewed.recent = parsed;
        }

        return parsed;
      }
    } catch (error) {
      return {};
    }

    return {};
  }

  function readProductInfo(handle) {
    var cache = theme.recentlyViewed && theme.recentlyViewed.productInfo;

    if (cache && cache[handle]) {
      return parseProduct(cache[handle]);
    }

    try {
      var raw = window.sessionStorage.getItem('recent-products');

      if (raw) {
        var parsed = JSON.parse(raw);

        if (theme.recentlyViewed) {
          theme.recentlyViewed.productInfo = parsed;
        }

        return parseProduct(parsed[handle]);
      }
    } catch (error) {
      return null;
    }

    return null;
  }

  function getRecentHandles(excludeHandle) {
    var recent = readRecentMap();

    return Object.keys(recent).filter(function (handle) {
      return handle && handle !== 'undefined' && handle !== excludeHandle;
    });
  }

  function getOptionName(option) {
    if (!option) {
      return '';
    }

    if (typeof option === 'string') {
      return option;
    }

    return option.name || '';
  }

  function isColorOption(name) {
    var normalized = (name || '').toLowerCase();

    return normalized.indexOf('couleur') !== -1
      || normalized.indexOf('color') !== -1
      || normalized.indexOf('colour') !== -1;
  }

  function getColorOptionIndex(product) {
    if (!product.options || !product.options.length) {
      return -1;
    }

    for (var i = 0; i < product.options.length; i++) {
      if (isColorOption(getOptionName(product.options[i]))) {
        return i;
      }
    }

    return -1;
  }

  function getImageSrc(image) {
    if (!image || !theme.Images) {
      return '';
    }

    if (typeof image === 'string') {
      return theme.Images.removeProtocol(image);
    }

    return theme.Images.removeProtocol(image.src || '');
  }

  function buildSrcset(src) {
    if (!src || !theme.Images) {
      return '';
    }

    return [360, 540, 720, 900, 1080].map(function (width) {
      var sized = theme.Images.getSizedImageUrl(src, width + 'x');
      return sized ? sized + ' ' + width + 'w' : null;
    }).filter(Boolean).join(', ');
  }

  function getProductData(handle) {
    var cached = readProductInfo(handle);

    if (cached) {
      return Promise.resolve(cached);
    }

    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('recent product fetch failed');
        }

        return response.json();
      })
      .then(function (product) {
        if (product) {
          if (!theme.recentlyViewed) {
            theme.recentlyViewed = { recent: {}, productInfo: {} };
          }

          if (!theme.recentlyViewed.productInfo) {
            theme.recentlyViewed.productInfo = {};
          }

          theme.recentlyViewed.productInfo[handle] = product;
        }

        return product;
      })
      .catch(function () {
        return null;
      });
  }

  function formatMoney(cents) {
    if (theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }

    return (cents / 100).toFixed(2);
  }

  function getProductFeaturedSrc(product) {
    if (product.featured_image) {
      return getImageSrc(product.featured_image);
    }

    if (product.images && product.images.length) {
      return getImageSrc(product.images[0]);
    }

    return '';
  }

  function buildPreviewButton(product, src, variantId, label) {
    if (!src) {
      return '';
    }

    var previewSrcset = buildSrcset(src);
    var thumbSrc = (theme.Images && theme.Images.getSizedImageUrl(src, '96x96')) || src;

    return '<button type="button" class="bdl-variant-preview" data-bdl-variant-preview' +
      ' data-preview-src="' + escapeHtml(src) + '"' +
      ' data-preview-srcset="' + escapeHtml(previewSrcset) + '"' +
      ' data-variant-id="' + variantId + '"' +
      ' aria-label="' + escapeHtml(label) + '"' +
      ' aria-pressed="false">' +
      '<img class="bdl-variant-preview__img" src="' + escapeHtml(thumbSrc) + '" alt="" width="48" height="48" loading="lazy">' +
      '</button>';
  }

  function countVariantPreviews(product) {
    if (!product || !product.variants || !product.variants.length) {
      return 0;
    }

    var colorIndex = getColorOptionIndex(product);
    var seen = {};
    var count = 0;
    var colorValuesCount = 0;

    if (colorIndex !== -1 && product.options && product.options[colorIndex]) {
      var colorOption = product.options[colorIndex];
      colorValuesCount = (colorOption.values && colorOption.values.length) || 0;
    }

    if (colorIndex !== -1) {
      product.variants.forEach(function (variant) {
        var value = variant['option' + (colorIndex + 1)];

        if (!value || seen[value]) {
          return;
        }

        seen[value] = true;

        var src = getImageSrc(variant.featured_image);

        if (!src && colorValuesCount === 1) {
          src = getProductFeaturedSrc(product);
        }

        if (src) {
          count += 1;
        }
      });
    }

    return count > 0 ? count : 1;
  }

  function buildVariantPreviews(product) {
    if (!product.variants || !product.variants.length) {
      return '';
    }

    var colorIndex = getColorOptionIndex(product);
    var seen = {};
    var buttons = [];
    var colorValuesCount = 0;

    if (colorIndex !== -1 && product.options && product.options[colorIndex]) {
      var colorOption = product.options[colorIndex];
      colorValuesCount = (colorOption.values && colorOption.values.length) || 0;
    }

    if (colorIndex !== -1) {
      product.variants.forEach(function (variant) {
        var value = variant['option' + (colorIndex + 1)];

        if (!value || seen[value]) {
          return;
        }

        seen[value] = true;

        var src = getImageSrc(variant.featured_image);

        if (!src && colorValuesCount === 1) {
          src = getProductFeaturedSrc(product);
        }

        if (!src) {
          return;
        }

        buttons.push(buildPreviewButton(product, src, variant.id, product.title + ' \u2014 ' + value));
      });
    }

    if (buttons.length < 1) {
      var fallbackVariant = product.variants[0];
      var fallbackSrc = getProductFeaturedSrc(product);
      var fallbackLabel = product.title;

      if (colorIndex !== -1 && product.options && product.options[colorIndex] && product.options[colorIndex].values && product.options[colorIndex].values[0]) {
        fallbackLabel = product.title + ' \u2014 ' + product.options[colorIndex].values[0];
      }

      var fallbackButton = buildPreviewButton(product, fallbackSrc, fallbackVariant.id, fallbackLabel);

      if (fallbackButton) {
        buttons.push(fallbackButton);
      }
    }

    if (buttons.length < 1) {
      return '';
    }

    return '<div class="bdl-variant-previews" data-bdl-variant-previews data-product-id="' + product.id + '">' +
      buttons.join('') +
      '</div>';
  }

  function buildPriceHtml(product) {
    var onSale = product.compare_at_price && product.compare_at_price > product.price;
    var html = '';

    if (onSale) {
      html += '<span class="visually-hidden">' + escapeHtml(theme.strings.regularPrice || 'Regular price') + '</span>';
      html += '<span class="grid-product__price--original">' + formatMoney(product.compare_at_price) + '</span>';
      html += '<span class="visually-hidden">' + escapeHtml(theme.strings.salePrice || 'Sale price') + '</span>';
    }

    var currentPrice;

    if (product.price_varies) {
      var formattedMin = formatMoney(product.price_min);
      currentPrice = (theme.strings.fromPriceHtml || 'from [price]').replace('[price]', formattedMin);
    } else {
      currentPrice = formatMoney(product.price);
    }

    html += '<span class="grid-product__price--current">' + currentPrice + '</span>';

    if (onSale && theme.settings.productSaveAmount !== false) {
      var savedAmount;

      if (theme.settings.saveType === 'dollar') {
        savedAmount = formatMoney(product.compare_at_price - product.price);
      } else {
        savedAmount = Math.round(
          (product.compare_at_price - product.price) * 100 / product.compare_at_price
        ) + '%';
      }

      html += '<span class="grid-product__price--savings">' +
        (theme.strings.savePrice || 'SAVE [saved_amount]').replace('[saved_amount]', savedAmount) +
        '</span>';
    }

    return '<div class="grid-product__price">' + html + '</div>';
  }

  function buildTags(product) {
    var onSale = product.compare_at_price && product.compare_at_price > product.price;

    if (!product.available) {
      return '<div class="grid-product__tag grid-product__tag--sold-out">' +
        escapeHtml(theme.strings.soldOut || 'Sold out') +
        '</div>';
    }

    if (onSale) {
      return '<div class="grid-product__tag grid-product__tag--sale">' +
        escapeHtml(theme.strings.sale || 'Sale') +
        '</div>';
    }

    return '';
  }

  function buildProductImage(product, recentMeta) {
    var imageSize = (theme.settings && theme.settings.productImageSize) || 'portrait';
    var featuredSrc = getImageSrc(product.featured_image) || getImageSrc(product.images && product.images[0]);
    var lazySrc = featuredSrc && theme.Images ? theme.Images.lazyloadImagePath(featuredSrc) : featuredSrc;
    var defaultSrc = featuredSrc && theme.Images
      ? (theme.Images.getSizedImageUrl(featuredSrc, '1080x') || featuredSrc)
      : featuredSrc;
    var defaultSrcset = buildSrcset(featuredSrc);
    var aspectRatio = recentMeta && recentMeta.aspectRatio ? recentMeta.aspectRatio : '125.0';
    var containClass = theme.settings && theme.settings.productImageCover ? '' : ' grid__image-contain';
    var alt = escapeHtml(product.title);

    if (recentMeta && recentMeta.featuredImage) {
      lazySrc = recentMeta.featuredImage;
    }

    if (imageSize === 'natural') {
      return '<div class="image-wrap" style="height: 0; padding-bottom: ' + aspectRatio + '%;">' +
        '<img class="grid-product__image lazyload" data-bdl-preview-image' +
        ' data-bdl-default-src="' + escapeHtml(defaultSrc || '') + '"' +
        ' data-bdl-default-srcset="' + escapeHtml(defaultSrcset) + '"' +
        ' data-src="' + escapeHtml(lazySrc || '') + '"' +
        ' data-widths="[360, 540, 720, 900, 1080, 1440]"' +
        ' data-aspectratio="' + escapeHtml(aspectRatio) + '"' +
        ' data-sizes="auto" alt="' + alt + '">' +
        '</div>';
    }

    return '<div class="grid__image-ratio grid__image-ratio--' + imageSize + '">' +
      '<img class="lazyload' + containClass + '" data-bdl-preview-image' +
      ' data-bdl-default-src="' + escapeHtml(defaultSrc || '') + '"' +
      ' data-bdl-default-srcset="' + escapeHtml(defaultSrcset) + '"' +
      ' data-src="' + escapeHtml(lazySrc || '') + '"' +
      ' data-widths="[360, 540, 720, 900, 1080, 1440]"' +
      ' data-aspectratio="' + escapeHtml(aspectRatio) + '"' +
      ' data-sizes="auto" alt="' + alt + '">' +
      '</div>';
  }

  function splitProductTitle(title) {
    if (!title) {
      return { name: '', desc: '' };
    }

    if (title.indexOf(' | ') !== -1) {
      var spaced = title.split(' | ');

      return {
        name: spaced[0].trim(),
        desc: spaced.slice(1).join(' | ').trim()
      };
    }

    if (title.indexOf('|') !== -1) {
      var parts = title.split('|');

      return {
        name: parts[0].trim(),
        desc: parts.slice(1).join('|').trim()
      };
    }

    return { name: title, desc: '' };
  }

  function buildTitleHtml(product) {
    var titleParts = splitProductTitle(product.title);
    var typeStyle = (theme.settings && theme.settings.typeProductStyle) || 'body';
    var descHtml = titleParts.desc
      ? '<span class="grid-product__title-desc">' + escapeHtml(titleParts.desc) + '</span>'
      : '';

    return '<div class="grid-product__title grid-product__title--split grid-product__title--' + escapeHtml(typeStyle) + '">' +
      '<span class="grid-product__title-name">' + escapeHtml(titleParts.name) + '</span>' +
      descHtml +
      '</div>';
  }

  function buildPreviewAction(product) {
    if (!document.body.classList.contains('template-product')) {
      return '';
    }

    return '<div class="bdl-cart-upsell__add bdl-product-row-preview">' +
      '<button type="button" class="bdl-cart-upsell__add-btn" data-bdl-cart-quick-add' +
      ' data-product-handle="' + escapeHtml(product.handle) + '"' +
      ' data-product-id="' + product.id + '">' +
      escapeHtml((theme.strings && theme.strings.upsellAdd) || 'Preview') +
      '</button></div>';
  }

  function buildProductCard(product, config) {
    var recentMap = readRecentMap();
    var recentMeta = recentMap[product.handle] || null;
    var url = (recentMeta && recentMeta.url) || product.url;
    var previewAction = buildPreviewAction(product);
    var metaFooter;

    if (previewAction) {
      metaFooter = '<div class="bdl-cart-upsell__card-footer">' +
        '<a href="' + escapeHtml(url) + '" class="grid-product__link grid-product__link--meta">' +
        '<div class="grid-product__meta">' +
        buildTitleHtml(product) +
        '</div></a>' +
        '<div class="bdl-cart-upsell__card-actions">' +
        buildPriceHtml(product) +
        previewAction +
        '</div></div>';
    } else {
      metaFooter = '<a href="' + escapeHtml(url) + '" class="grid-product__link grid-product__link--meta">' +
        '<div class="grid-product__meta">' +
        buildTitleHtml(product) +
        buildPriceHtml(product) +
        '</div></a>';
    }

    return '<div class="grid__item grid-product ' + config.gridItemWidth + ' aos-animate"' +
      ' data-aos="row-of-' + config.rowOf + '"' +
      ' data-product-handle="' + escapeHtml(product.handle) + '"' +
      ' data-product-id="' + product.id + '">' +
      '<div class="grid-product__content">' +
      '<a href="' + escapeHtml(url) + '" class="grid-product__link grid-product__link--image">' +
      '<div class="grid-product__image-mask">' +
      buildTags(product) +
      buildProductImage(product, recentMeta) +
      '</div></a>' +
      buildVariantPreviews(product) +
      metaFooter +
      '</div></div>';
  }

  function refreshLazyImages(container) {
    if (!container || !window.lazySizes || !lazySizes.loader) {
      return;
    }

    lazySizes.loader.checkElems();
  }

  function getOutputContainer(container) {
    var sectionId = container.getAttribute('data-section-id');

    if (sectionId) {
      var byId = document.getElementById('RecentlyViewed-' + sectionId);

      if (byId) {
        return byId;
      }
    }

    return container.querySelector('[id^="RecentlyViewed-"]');
  }

  function getFallbackEl(container) {
    return container.querySelector('[data-bdl-rv-fallback]');
  }

  function getRecentGridEl(container) {
    return container.querySelector('[data-bdl-recently-viewed-grid]');
  }

  function getTitleEl(container) {
    return container.querySelector('[data-bdl-rv-title]');
  }

  function showFallback(container) {
    var fallback = getFallbackEl(container);
    var recentGrid = getRecentGridEl(container);
    var title = getTitleEl(container);

    if (fallback) {
      fallback.classList.remove('hide');
    }

    if (recentGrid) {
      recentGrid.classList.add('hide');
    }

    if (title && title.getAttribute('data-fallback-title')) {
      title.textContent = title.getAttribute('data-fallback-title');
    }

    if (fallback) {
      container.classList.remove('hide');
      return;
    }

    container.classList.add('hide');
  }

  function showRecentlyViewed(container) {
    var fallback = getFallbackEl(container);
    var recentGrid = getRecentGridEl(container);
    var title = getTitleEl(container);

    if (fallback) {
      fallback.classList.add('hide');
    }

    if (recentGrid) {
      recentGrid.classList.remove('hide');
    }

    if (title && title.getAttribute('data-recent-title')) {
      title.textContent = title.getAttribute('data-recent-title');
    }

    container.classList.remove('hide');
  }

  function renderRecentlyViewed(container) {
    if (!container || container.getAttribute('data-bdl-rv-loading') === 'true') {
      return;
    }

    var outputContainer = getOutputContainer(container);

    if (!outputContainer) {
      return;
    }

    var excludeHandle = container.getAttribute('data-product-handle') || '';
    var handles = getRecentHandles(excludeHandle);

    if (!handles.length) {
      showFallback(container);
      return;
    }

    container.setAttribute('data-bdl-rv-loading', 'true');

    handles.reverse();
    handles = handles.slice(0, parseInt(container.getAttribute('data-recent-count'), 10) || 5);

    var config = {
      gridItemWidth: container.getAttribute('data-grid-item-class') || 'small--one-half medium-up--one-fifth',
      rowOf: container.getAttribute('data-row-of') || '5'
    };

    Promise.all(handles.map(getProductData))
      .then(function (products) {
        var markup = '';
        var count = 0;

        products = products.filter(function (product) {
          return product && product.handle;
        });

        products.sort(function (a, b) {
          return countVariantPreviews(b) - countVariantPreviews(a);
        });

        products.forEach(function (product) {
          try {
            markup += buildProductCard(product, config);
            count++;
          } catch (error) {
            console.error('Recently viewed card failed for ' + product.handle, error);
          }
        });

        container.removeAttribute('data-bdl-rv-loading');

        if (!count) {
          showFallback(container);
          return;
        }

        outputContainer.innerHTML = markup;
        showRecentlyViewed(container);
        refreshLazyImages(outputContainer);

        // Cards already include aos-animate. Skip AOS.refreshHard() — it
        // resets overflow slide animations on earlier rows (More you'll love).

        try {
          if (theme.config && theme.config.hasSessionStorage && theme.recentlyViewed && theme.recentlyViewed.productInfo) {
            sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
          }
        } catch (error) {
          return;
        }
      })
      .catch(function (error) {
        container.removeAttribute('data-bdl-rv-loading');
        showFallback(container);
        console.error('Recently viewed failed to load', error);
      });
  }

  function bootRecentlyViewed() {
    document.querySelectorAll('[data-section-type="recently-viewed"]').forEach(function (container) {
      var output = getOutputContainer(container);
      var isReady = container.getAttribute('data-bdl-rv-ready') === 'true';
      var hasCards = output && output.children.length > 0;

      if (isReady && hasCards) {
        return;
      }

      container.setAttribute('data-bdl-rv-ready', 'true');
      container.classList.remove('hide');
      container.removeAttribute('data-bdl-rv-loading');
      renderRecentlyViewed(container);
    });
  }

  theme.RecentlyViewed = function () {};

  document.addEventListener('page:loaded', bootRecentlyViewed);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootRecentlyViewed);
  } else {
    bootRecentlyViewed();
  }
})();
